/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import React, { FunctionComponent } from "react";
import styled from "../../../themes/global";
import { HTMLCustomProps } from "../../../types/css";

export const Ecard = styled("div")`
  background-color: ${(props) => props.theme.color.primary};
  border-radius: 4px;
  color: ${(props) => props.theme.color.white};
  font-size: 16px;
  box-shadow: 0px 1px 4px rgba(51, 51, 51, 0.25);
  margin: 0;
  outline: none;
  padding: 4px 12px;
`;

const Card: FunctionComponent<HTMLCustomProps<HTMLDivElement>> = (props) => {
  return <Ecard {...props}>{props.children}</Ecard>;
};

export default Card;
